<template>
  <v-container id="page-notice-list">
    <div class="page-title">{{$route.name}}</div>
    <v-col class="d-flex justify-end">
      <c-btn color="blue" class="ml-1" outlined iconName="add" @click="onWriteNotice()">공지 등록</c-btn>
    </v-col>
    <c-table
      :headers="noticeTableHeaders"
      itemKey="id"
      :items="noticeList"
      @click="onNoticeBoardDetail"
    >
      <template #criticalFlag="{ item }">
        <div v-if="item.criticalFlag === 'T'">
          <v-icon color="red">warning</v-icon>
        </div>
        <div v-else>
        </div>
      </template>

      <template #created="{ item }">
        <div>
          {{$func.dateToString(item.created)}}
        </div>
      </template>

      <template #centerName="{item}">
        {{item.centerId.centerName}}
      </template>

      <template #creatorName="{item}">
        {{item.creatorId.name}}
      </template>

      <template #pushFlag="{ item }">
        <div v-if="item.pushFlag === 'T'">
          완료
        </div>
        <div v-else>
          미완료
        </div>
      </template>

    </c-table>
  </v-container>
</template>
<script>
  export default {
    data() {
      return {
        noticeCUDialog: false,
        noticeTableHeaders: [
          {
            text: '센터',
            value: 'centerName',
            align: 'center',
            sortable: true,
          },
          {
            text: '',
            value: 'criticalFlag',
            align: 'right',
            sortable: false,
          },
          {
            text: '제목',
            value: 'noticeTitle',
            align: 'left',
            sortable: true,
          },
          {
            text: '푸시 여부',
            value: 'pushFlag',
            align: 'center',
            sortable: false,
          },
          {
            text: '작성자',
            value: 'creatorName',
            align: 'center',
            sortable: true,
          },
          {
            text: '작성일',
            value: 'created',
            align: 'center',
            sortable: true,
          }
        ],
        noticeInfo: null,
        noticeList: [],
        startMenu: false,
        endMenu: false,
      }
    },
    activated() {
      this.reqNoticeList();
    },
    methods: {
      // onEditInfo(data) {
      //   this.noticeInfo = {
      //     id: data.id,
      //     noticeContents: data.noticeContents,
      //     noticeTitle: data.noticeTitle,
      //     selectCritical: data.criticalFlag
      //   };
      //   this.noticeCUDialog = true;
      // },


      onWriteNotice() {
        this.$router.push('/noticeWrite');
      },
      async reqNoticeList() {
        try {
          const res = await this.$api.getNoticeList();
          this.noticeList = res.data;
        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'reqReservation'});
        }
      },
      onNoticeBoardDetail(data) {
        this.$router.push(`/noticeboard/${data.id}`);
      }
    }
  }
</script>
<style scoped>

</style>
